<template>
    <div>
        <div class="row">
            <div class="col-lg-3 d-none d-lg-block" style="height: 85vh;"></div>
            <div class="col-lg-6 d-flex align-items-center mt-5 mt-lg-0">
                <div class="card login w-100 p-5">
                    <h2 class="text-center mb-4">ویرایش پروفایل</h2>
                    <div class="row">
                        <div class="col-lg-6 offset-lg-3 mt-3">
                            <div class="input-group not-clickable">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fa fa-mobile-phone"></i></span>
                                </div>
                                <input class="form-control not-clickable" v-model="user.phoneNumber" disabled/>
                            </div>
                        </div>
                        <div class="col-lg-12  mt-3">
                            <div class="input-group not-clickable">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"> کد معرف شما :  <small style="white-space:pre-wrap">(دوستان شما این کد را به عنوان کد معرف در زمان ثبت نام وارد میکنند)</small></span>
                                </div>
                                <input class="form-control not-clickable" v-model="user.presenterCode" disabled/>
                            </div>
                        </div>
                        <div class="col-lg-6 mt-3">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">نام</span>
                                </div>
                                <input class="form-control" v-model="user.personName"/>
                            </div>
                        </div>
                        <div class="col-lg-6 mt-3">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">نام خانوادگی</span>
                                </div>
                                <input class="form-control" v-model="user.personBigName"/>
                            </div>
                        </div>
                        <div class="col-lg-6 mt-3">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">استان</span>
                                </div>
                                <vs-select :data="provinces" :mode="'create'" :selected-val="preselectedProvince"
                                           :header="{multiple: false, label: 'name'}"
                                           @onChange="onProvinceChange"></vs-select>
                            </div>
                        </div>
                        <div class="col-lg-6 mt-3">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">شهر</span>
                                </div>
                                <vs-select :data="cities" :mode="'create'" :selected-val="preselectedCity"
                                           :header="{multiple: false, label: 'name'}"
                                           @onChange="onCityChange"></vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="text-center">
                        <button class="btn btn-primary mt-3 w-50" @click="onSubmitClicked">ذخیره</button>
                    </div>

                    <h2 class="text-center m-4" v-if="company!=null">ویرایش فروشگاه</h2>
                    <div class="row" v-if="company!=null">
                        <div class="col-lg-6 mt-3">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">نام فروشگاه</span>
                                </div>
                                <input class="form-control" v-model="company.companyName"/>
                            </div>
                        </div>
                        <div class="col-lg-12 mt-3">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">لینک سرور(لطفا تغییر ندهید، فروشگاه از کار میافتد)</span>
                                </div>
                                <input class="form-control" v-model="company.serverLink"/>
                            </div>
                        </div>
                        <div class="col-lg-6 mt-3">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">کد اقتصادی</span>
                                </div>
                                <input class="form-control" v-model="company.codeEghtesadi"/>
                            </div>
                        </div>
                        <div class="col-lg-6 mt-3">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">کد ملی</span>
                                </div>
                                <input class="form-control" v-model="company.codeMelli"/>
                            </div>
                        </div>
                        <div class="col-lg-6 mt-3">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">موبایل فروشگاه</span>
                                </div>
                                <input class="form-control" v-model="company.mobile"/>
                            </div>
                        </div>
                        <div class="col-lg-6 mt-3">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">تلفن فروشگاه</span>
                                </div>
                                <input class="form-control" v-model="company.phone"/>
                            </div>
                        </div>
                        <div class="col-lg-6 mt-3">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">آدرس</span>
                                </div>
                                <input class="form-control" v-model="company.address"/>
                            </div>
                        </div>
                        <div class="col-lg-6 mt-3">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">کد پستی</span>
                                </div>
                                <input class="form-control" v-model="company.codePosti"/>
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <div class="">
                                <small class="d-flex justify-content-center">عکس با فرمت png و اندازه مربعی وارد کنید</small>
                                <span class="">
                                            <img :src="baseURL + company.logoAddress" class="profile-image ">
                                            <hr/>
                                        </span>
                                <span class="" v-if="newImageCliked">
                                            <img :src="newImage" class="profile-image ">
                                            <hr/>
                                        </span>
                            </div>
                            <input type="file" id="fileUpload" class="d-none"
                                   @change="onImageChange($event)">
                            <label for="fileUpload" class="btn btn-info btn-round mb-3 clickable">بارگذاری
                                فایل</label>
                        </div>

                    </div>
                    <div class="text-center" v-if="company!=null">
                        <button class="btn btn-primary mt-3 w-50" @click="onSubmitClicked2">ذخیره</button>
                    </div>


                    <div class="col-lg-12  mt-3">
                        <div class="input-group not-clickable">
                            <div>
                                <span class="text-center">در صورت وجود ابهام یا سوال میتوانید در ساعات اداری با شماره (32762217-026) و در ساعات غیر اداری با شماره (09222760495) تماس بگیرید</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4"></div>
        </div>
    </div>
</template>

<script>
    import EventBus from '../_framework/event-bus.js';
    import * as $ from "jquery";
    import axios from "axios";
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";
    import VsSelect from "../_framework/VsSelect";
    import Constants from "../Constants";
    import Cities from '../_framework/api/Cities'

    export default {
        name: 'profile',
        components: {VsSelect},
        data() {
            return {
                baseURL: "",
                newImageCliked: false,
                newImage: "",
                user: {
                    personName: "",
                    personBigName: "",
                    phoneNumber: "",
                    city: "",
                    province: "",
                    image: "",
                    gender: 1
                },
                company: null,
                // company: {
                //     id: 0,
                //     companyName: "",
                //     serverLink: "",
                //     codeEghtesadi: "",
                //     codeMelli: "",
                //     mobile: "",
                //     phone: "",
                //     address: "",
                //     codePosti: "",
                //     logoAddress: "",
                //     logoExtention: ""
                // },
                provinces: [],
                cities: [],
                preselectedProvince: {},
                preselectedCity: {}
            }
        },
        mounted() {
            this.provinces = Cities;
            $("#avatar").on("change", () => {
                var preview = $("#user-img");
                var file = document.querySelector('input[type=file]').files[0];
                var reader = new FileReader();
                var base64;
                reader.addEventListener("load", function () {
                    $("#user-img").attr("src", reader.result);
                    //this.user.image = reader.result;
                    base64 = reader.result;
                }, false);
                setTimeout(() => {
                    this.user.image = base64;
                }, 1000);

                if (file) {
                    reader.readAsDataURL(file);
                }
            });
            this.baseURL = Constants.AUTH_BASE_URL;
            axios.defaults.baseURL = Constants.AUTH_API_BASE_URL;
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem("token_mobile");
            axios.get('persons/0').then(response => {
                this.user = response.data;
                localStorage.setItem("userId", this.user.id);
                $("#user-img").attr('src', this.user.image);
                this.preselectedProvince = {name: this.user.province};
                this.preselectedCity = {name: this.user.city};
            });
            if (localStorage.getItem("companyId") !== undefined && localStorage.getItem("companyId") !== null && localStorage.getItem("companyId") !== "" && localStorage.getItem("companyId") !== "0") {
                this.getCompany();
            }
            this.user.phoneNumber = localStorage.getItem("phoneNumber");
            /*axios.get('Worker/GetCities').then(response => {
                this.cities = response.data.cities;
                for (let item of this.cities) {
                    if (item.cityId === parseInt(this.user.cityCode)) {
                        this.preselectedCity = item;
                    }
                }
            });*/
        },
        methods: {
            getCompany() {
                axios.get(`Company/GetById/${localStorage.getItem("companyId")}`).then(response => {
                    if (response.data != null && response.data.companyName !== undefined) {
                        this.company = response.data;
                        localStorage.setItem("codeEghtesadi", this.company.codeEghtesadi);
                        localStorage.setItem("codeMelli", this.company.codeMelli);
                        localStorage.setItem("companymobile", this.company.mobile);
                        localStorage.setItem("companyphone", this.company.phone);
                        localStorage.setItem("companyaddress", this.company.address);
                        localStorage.setItem("logoAddress", this.baseURL + this.company.logoAddress);
                    }
                });
            },
            onSubmitClicked() {
                this.user.gender = 1;
                if (this.user.image != null) {
                    this.user.image = this.user.image.split(",").pop();
                }
                axios.put('persons', this.user).then(response => {
                    if (JSON.parse(localStorage.getItem("isRegistered"))) {
                        this.$noty.success('اطلاعات کاربری با موفقیت ویرایش شد!');
                    } else {
                        this.$noty.success('اطلاعات کاربری با موفقیت ثبت شد!');
                    }
                    localStorage.setItem("isRegistered", "true");
                    this.$router.push({name: 'select-store'});
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                });
            },
            onSubmitClicked2() {

                axios.put('Company/UpdateCompany', this.company).then(response => {
                    this.getCompany();
                    this.$router.push({name: 'home'});
                }).catch(error => {
                    this.getCompany();
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                });
            },
            onProvinceChange(val) {
                let province = this.provinces.find(element => {
                    return element === val;
                });
                this.user.province = val.name;
                this.cities = province.cities;
            },
            onCityChange(val) {
                this.user.city = val.name;
            },
            onImageChange(e) {
                let files = e.target.files;
                let app = this;
                if (files && files[0]) {
                    this.newImageCliked = true;
                    for (let item of files) {
                        let extension = item.name.slice((item.name.lastIndexOf(".") - 1 >>> 0) + 2);
                        let reader = new FileReader();
                        reader.onload = function (e) {
                            // $("#bannerImg").attr("src", e.target.result);
                            let a = e.target.result;
                            // let img = document.getElementById('docImg');
                            // img.src = e.target.result;
                            let bb = {};
                            bb.name = item.name;
                            bb.address = a.substring(a.indexOf(',') + 1, a.length);
                            bb.extension = extension;
                            bb.newImage = e.target.result;
                            app.company.logoAddress = a.substring(a.indexOf(',') + 1, a.length);
                            app.company.logoExtention = extension;
                            app.newImage = e.target.result;
                            app.isSending = true;
                            // new BaseService("Product", "/CreateProductImage").create(bb).then(response => {
                            //     bb.documentId = response.data;
                            //     // let attach = {documentId: response.data};
                            //     app.product.productImages.push(response.data);
                            //     app.isSending = false;
                            //     app.helpDocumentModel = bb;
                            // }).catch(error => {
                            //     app.isSending = false;
                            //     app.$noty.error("متاسفانه خطایی رخ داده است." + error.data);
                            //     console.log(error)
                            //     // Utils.handleErrorWithNotification("خطا!! لطفا پارامترها را مجددا بررسی کنید", this.$noty);
                            // });

                        };
                        reader.readAsDataURL(item);
                        // } else {
                        //     alert("لطفا فایل عکس بارگذاری کنید");
                        // }
                    }
                }
            },

        },
        watch: {
            newImage(val) {

            }
        },
    }
</script>

<style lang="scss" scoped>
    .user-img {
        max-width: 125px;
        border-radius: 100%;
    }
</style>